import { render, staticRenderFns } from "./Redeem05.vue?vue&type=template&id=7965efac&scoped=true&"
import script from "./Redeem05.vue?vue&type=script&lang=js&"
export * from "./Redeem05.vue?vue&type=script&lang=js&"
import style0 from "./Redeem05.vue?vue&type=style&index=0&id=7965efac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7965efac",
  null
  
)

export default component.exports